module.exports = __webpack_public_path__ + "media/app/assets/races/vulpera_male-359f577f2cbd4d19d531ec5c8e57514d.png";